export default __webpack_public_path__ + "static/media/edit.8c1e6221.svg";